import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../contexts'

export function LogoutPage() {
  const { signOut } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    // Perform logout immediately
    const performLogout = async () => {
      await signOut()
      // Navigation is handled in signOut, but fallback just in case
      navigate('/login', { replace: true })
    }

    performLogout()
  }, [signOut, navigate])

  // Show loading state while signing out
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-600 text-lg">Signing out...</p>
      </div>
    </div>
  )
}
